<template>
  <div class="persona-selector">
    <div class="layout layout--primary">
      <div class="layout__container">
        <div class="grid grid--primary">
          <div v-for="persona in personaList" :key="persona.id" class="persona-selector__col">
            <n-link
              :to="localePath({ name: 'persona-persona', params: { persona: persona.param } })"
              class="persona-selector__btn btn btn--primary btn--medium"
            >
              {{ $t(persona.name) }}
            </n-link>
            <responsive-img
              v-if="persona.image"
              v-bind="persona.image"
              :resolutions="[1]"
              :width="500"
              alt=""
              class="persona-selector__img"
            />
            <div class="persona-selector__description">
              <p>
                {{ $t(`persona_selector.${persona.id}.description`) }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { getImage } from '@/assets/js/util/misc/image'
  import { personaList } from '@/assets/js/model/persona'
  import ResponsiveImg from '@/components/responsive-img/responsive-img'

  export default {
    components: { ResponsiveImg },
    props: {},
    computed: {
      personaList() {
        return personaList.filter(({ isPersona }) => isPersona)
      },
    },
    getImage,
  }
</script>

<style lang="scss" src="./_persona-selector.scss" />
